// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VJgYcvonJfmsLrc6vyRO{display:flex;flex-direction:column;height:100%}.sy8siFEV2vAlUeXkLWRp{padding:0;margin:0 7px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/members/layout/RequestsLayout/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,WAAA,CAGF,sBACE,SAAA,CACA,YAAA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.tabs {\n  padding: 0;\n  margin: 0 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VJgYcvonJfmsLrc6vyRO`,
	"tabs": `sy8siFEV2vAlUeXkLWRp`
};
export default ___CSS_LOADER_EXPORT___;
